"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.getCurrentUser = exports.isLoggedIn = void 0;

var _netlifyIdentityWidget = _interopRequireDefault(require("netlify-identity-widget"));

if (typeof window !== 'undefined') {
  window.netlifyIdentity = _netlifyIdentityWidget.default;
}

var isLoggedIn = function isLoggedIn() {
  var user = _netlifyIdentityWidget.default.currentUser();

  return Boolean(user);
};

exports.isLoggedIn = isLoggedIn;

var getCurrentUser = function getCurrentUser() {
  return _netlifyIdentityWidget.default.currentUser();
};

exports.getCurrentUser = getCurrentUser;